import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { animateScroll } from "react-scroll";
import CookieConsent, { Cookies } from "react-cookie-consent";
import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  0% { background-color: yellow; }
  50% { background-color: transparent; }
  100% { background-color: yellow; }
`;

const Highlight = styled.span`
  background-color: yellow;
  padding: 2px 4px;
  animation: ${pulse} 1.5s infinite;
`;
const FooterTwo = ({
  backgroundColorClass,
  spaceLeftClass,
  spaceRightClass,
  footerTopBackgroundColorClass,
  footerTopSpaceTopClass,
  footerTopSpaceBottomClass,
}) => {
  const [scroll, setScroll] = useState(0);
  const [top, setTop] = useState(0);
  useEffect(() => {
    setTop(100);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    animateScroll.scrollToTop();
  };

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  var informazioni = global.informazioni;

  return (
    <footer
      style={{ maxWidth: "100%" }}
      className={`footer-area ${
        backgroundColorClass ? backgroundColorClass : ""
      } ${spaceLeftClass ? spaceLeftClass : ""} ${
        spaceRightClass ? spaceRightClass : ""
      }`}
    >
      <div
        style={{ paddingBottom: "0px" }}
        className={`footer-top text-center ${
          footerTopBackgroundColorClass ? footerTopBackgroundColorClass : ""
        } ${footerTopSpaceTopClass ? footerTopSpaceTopClass : ""}  ${
          footerTopSpaceBottomClass ? footerTopSpaceBottomClass : ""
        }`}
      >
        <br />
        <div className="container" style={{ color: "black" }}>
          <div className="footer-logo">
            {global.aziendaID == 1 ? (
              <Link to={process.env.PUBLIC_URL}>
                <img
                  alt=""
                  src={informazioni.logoUrl}
                  style={{ width: "150px" }}
                />
              </Link>
            ) : (
              <img
                alt=""
                src={informazioni.logoUrl}
                style={{ width: "150px" }}
              />
            )}
          </div>
          <div>{informazioni.slogan}</div>
          <div>
            <table style={{ width: "100%" }}>
              {informazioni.indirizzoSedeLegale != "" && (
                <tr>
                  <td
                    style={{
                      textAlign: "right",
                      width: "40%",
                      verticalAlign: "top",
                    }}
                  >
                    Sede legale &nbsp;&nbsp;
                  </td>
                  <td style={{ textAlign: "left", width: "50%" }}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: informazioni.indirizzoSedeLegale,
                      }}
                    />{" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: informazioni.localitàSedeLegale,
                      }}
                    />{" "}
                  </td>
                </tr>
              )}
              {informazioni.indirizzoSedeOperativa != "" && (
                <tr>
                  <td
                    style={{
                      textAlign: "right",
                      width: "40%",
                      verticalAlign: "top",
                    }}
                  >
                    Sede operativa&nbsp;&nbsp;
                  </td>
                  <td style={{ textAlign: "left", width: "50%" }}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: informazioni.indirizzoSedeOperativa,
                      }}
                    />{" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: informazioni.localitàSedeOperativa,
                      }}
                    />
                  </td>
                </tr>
              )}
            </table>
            Partita iva {informazioni.piva}
            <br />
            {global.aziendaID == 1 && (
              <>
                ---{" "}
                <Link to={process.env.PUBLIC_URL + "/privacy-policy"}>
                  Cookie policy
                </Link>{" "}
                ---{" "}
              </>
            )}
            <br />
            {global.aziendaID == 1 && (
              <>
                <Highlight>
                  {" "}
                  ---{" "}
                  <Link to={process.env.PUBLIC_URL + "/condizioni-vendita"}>
                    Condizioni di vendita
                  </Link>{" "}
                  ---{" "}
                </Highlight>
              </>
            )}
          </div>
          {/*<div className="footer-social">
            <ul>
              <li>
                <a href="//www.facebook.com">
                  <i className="fa fa-facebook" />
                </a>
              </li>
              <li>
                <a href="//www.dribbble.com">
                  <i className="fa fa-dribbble" />
                </a>
              </li>
              <li>
                <a href="//www.pinterest.com">
                  <i className="fa fa-pinterest-p" />
                </a>
              </li>
              <li>
                <a href="//www.twitter.com">
                  <i className="fa fa-twitter" />
                </a>
              </li>
              <li>
                <a href="//www.linkedin.com">
                  <i className="fa fa-linkedin" />
                </a>
              </li>
            </ul>
          </div>*/}
        </div>
      </div>
      <div
        className="footer-bottom text-center"
        style={{ paddingBottom: "50px" }}
      >
        <div className="container">
          <div className="copyright-2 copyright-gray">
            <p>
              © {new Date().getFullYear()}{" "}
              <a
                href="//www.pegasogest.com"
                rel="noopener noreferrer"
                target="_blank"
              >
                Pegaso Gest
              </a>
              . All Rights Reserved. (17/07/2025)
            </p>
          </div>
        </div>
        {/*<CookieConsent
          location="bottom"
          buttonText="Ok, ho capito"
          cookieName="cookieconsent"
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={2}
        >
          Questo sito usa cookie per migliorare l'esperienza utente.{" "}
          <span style={{ fontSize: "10px" }}><Link style={{ color: "gray" }} to={process.env.PUBLIC_URL + "/privacy-policy"}>Privacy policy</Link></span>
        </CookieConsent>*/}
      </div>
      <button
        className={`scroll-top ${scroll > top ? "show" : ""}`}
        onClick={() => scrollToTop()}
      >
        <i className="fa fa-angle-double-up"></i>
      </button>
    </footer>
  );
};

FooterTwo.propTypes = {
  backgroundColorClass: PropTypes.string,
  footerTopBackgroundColorClass: PropTypes.string,
  footerTopSpaceBottomClass: PropTypes.string,
  footerTopSpaceTopClass: PropTypes.string,
  spaceLeftClass: PropTypes.string,
  spaceRightClass: PropTypes.string,
};

export default FooterTwo;
